export const USER_ROLES = {
  DESIGNER: 'designer',
  ADMINISTRATOR: 'administrator',
  TEACHER: 'teacher',
}

/**
 * Because of legacy reasons, some permissions come in the user roles
 * and some come in the user features.
 *
 * This is a list of user features that are not roles.
 */
export const USER_FEATURES = {
  MY_ARTICLES: 'my_articles',
}
